// Original
// import API from "./api";
// const apiUrl = "https://localhost:44378/api";

// export function httpClient() {
//   return {
//     get: (path, options) => {
//       debugger;
//       return API.get(apiUrl + path, { ...options });
//     },
//     post: async(path, body, options = {}) => {
//       debugger;
//       return await API.post(apiUrl + path, body ,{
//         ...options,
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           ...options.headers
//         }
//       });
//     },
//     put: (path, body, options = {}) => {
//       return API.put(apiUrl + path, {
//         ...options,
//         method: "POST",
//         body: JSON.stringify(body),
//         headers: {
//           "Content-Type": "application/json",
//           ...options.headers
//         }
//       });
//     },
//     delete: (path, options = {}) => {
//       return API.delete(apiUrl + path, {...options});
//     }
//   };
// }

// -------------Mine----------------
// import API from "./api";
// import { api as factory } from "services/ApiFactory";

// export function httpClient(apiUrl) { 
//   const api = API(apiUrl);
//   return { 
//     get: async (path, options) =>{
//       return await api.get(apiUrl + path, { ...options }).catch(function (error) {
//         if (error.response && error.response.status === 401 ) {
//           console.log(error.response.status);
//           factory.authentication.newTokenWithRefreshToken().then(result => {
//             if(result)
//             {
//               return  api.get(apiUrl + path, { ...options });
//             } else {
//               factory.authentication.logout();
//             }
//           });
//         }
//       });
//     },
//     post: async(path, body, options = {}) => {
//       return await api.post(apiUrl + path, body ,{
//         ...options,
//         method: "POST",
//         headers: {
//           ...options.headers
//         }
//       }).catch(function (error) {
//         if (error.response && error.response.status === 401 ) {
//           console.log(error.response.status);
//           factory.authentication.newTokenWithRefreshToken().then(result => {
//             if(result)
//             {
//               return  api.get(apiUrl + path, { ...options });
//             } else {
//               factory.authentication.logout();
//             }
//           });
//         }
//       });
//     },
//   } 
// }

// Second Original
import API from "./api";

export function httpClient(apiUrl) {
  const api = API(apiUrl);
  return {
    get: (path, options) => {
      return api.get( path, { ...options });
    },
    post: async (path, body, options = {}) => { 
      return await api.post( path, body
        , {
          ...options,
          method: "POST",
          headers: {
            ...options.headers
          }
        }
      );
    },
  }
}